import { ITheme } from 'survey-core'

export const darkTheme: ITheme = {
  themeName: 'sharp',
  colorPalette: 'dark',
  isPanelless: false,
  backgroundImage: '',
  backgroundImageFit: 'cover',
  backgroundImageAttachment: 'scroll',
  backgroundOpacity: 1,
  cssVariables: {
    '--background': '#263238',
    '--background-dim': '#171E21',
    '--foreground': '#F0F3F5',
    '--ctr-surface-placeholder-text-title-color': '#F0F3F5',
    '--ctr-surface-placeholder-text-description-color': '#F0F3F5',
    '--lbr-question-panel-background-color': '#263238',
    '--ctr-list-item-text-color': '#F0F3F5',
    '--ctr-list-item-text-color-hovered': '#F0F3F5',
    '--ctr-list-item-background-color-hovered': '#171E21',
    '--ctr-button-background-color-hovered': '#000000',
    '--ctr-list-search-text-color': '#F0F3F5',
    '--background-dim-light': '#37474F',
    '--sjs-font-pagetitle-color': '#F0F3F5',
    '--sjs-general-forecolor': '#F0F3F5',
    '--sjs-general-forecolor-light': 'rgba(185, 178, 178, 0.45)',
    '--sjs-general-backcolor': '#263238',
    '--sjs-general-backcolor-dark': '#37474F',
    '--sjs-general-backcolor-dim-light': '#37474F',
    '--sjs-font-editorfont-color': '#F0F3F5',
    '--sjs-questionpanel-backcolor': '#263238',
    '--sjs-questionpanel-hovercolor': '#37474F',
    '--sjs-editorpanel-backcolor': '#37474F',
    '--sjs-editor-background': '#37474F',
    '--sjs-primary-backcolor': '#2186A6',
    '--sjs-primary-backcolor-dark': '#42A4C2',
  },
  header: {
    height: 0,
    mobileHeight: 0,
    inheritWidthFrom: 'survey',
    textAreaWidth: 0,
    backgroundImageFit: 'cover',
    backgroundImageOpacity: 100,
    overlapEnabled: false,
    logoPositionX: 'left',
    logoPositionY: 'top',
    titlePositionX: 'left',
    titlePositionY: 'bottom',
    descriptionPositionX: 'left',
    descriptionPositionY: 'bottom',
  },
}

export default function applyCustomClass(themeMode: string) {
  const styleId = 'surveyjs-app-theme-overrides'
  document.getElementById(styleId)?.remove()

  const styles = document.createElement('style')
  styles.id = styleId

  if (themeMode === 'dark') {
    styles.innerHTML = `
        .sd-input--readonly,
        .sd-input.sd-input--readonly {
            background-color: #37474F !important;
            color: #F0F3F5 !important;
        }
        `
  }

  document.head.appendChild(styles)
}
